module.exports = __webpack_public_path__ + "assets/images/cockpit/active/btn_closedc_off_ru.png";